<template>
  <div>
    <loader v-if="loading"></loader>
    <div v-else>
        <div
          v-if="saveMessage"
          class="alert alert-success bg-green-light border border-green text-sm text-green px-4 py-3 rounded relative mb-4"
        >{{ $t('declarations.success') }}</div>
      <div v-if="session.application_session && labelData!=null && labelData.created == false || (companyData && !companyData.email)">
        <h2
          class="text-red text-lg text-bold mb-5 pb-2 uppercase"
        >{{ $t('requests.msg_no_company_declarations') }}</h2>
        <sp-button
          theme="outline-blue"
          space="small"
          @click="CompanyLink"
          type="submit"
          :disabled="(session.startup_application.user_id != session.user_auth.id)"
          :class="{'opacity-25 cursor-not-allowed': (session.startup_application.user_id != session.user_auth.id )}"
        >{{ $t('requests.link_company') }}</sp-button>
      </div>
      <div v-else>
      <h1
        class="text-red text-lg text-bold mb-5 pb-2 border-red-light border-b uppercase"
      >{{ this.decalarationsPageTitle }}</h1>
        <div v-if="requets_declarations">
          <div class="bg-white shadow-md rounded my-6" v-if="requets_declarations.length>0">
            <table class="text-left w-full border-collapse">
            <tbody>
              <tr
                class="hover:bg-grey-lighter"
                v-for="(lab, index) in requets_declarations"
                :key="index"
              >
                <td class="py-4 px-6 border-b border-grey-light">{{ lab.name }}</td>
                  <td
                    class="py-4 px-6 border-b border-grey-light text-right"
                  >
                    <sp-button
                      theme="outline-blue"
                      space="small"
                      :disabled="shouldDisableButton(lab)"
                      @click="applyRequest(formatDeclarationCodeName(lab.code_name))"
                    >{{ $t('declarations.make_declaration') }}</sp-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      <tabs></tabs>
      </div>
    </div>
  </div>
</template>

<style>
table.border-separate {
  border-spacing: 0 10px;
}

table.border-separate tbody tr {
  box-shadow: 0 2px 4px 0 rgba(29, 57, 100, 0.16);
  border-radius: 4px;
}

table.border-separate tbody tr:hover {
  box-shadow: 0 4px 8px 0 rgba(22, 66, 132, 0.19);
}

.table.border-separate tbody td {
  vertical-align: middle;
  border-color: rgba(29, 57, 100, 0.13);
}

.table.border-separate tbody tr:hover td {
  border-color: rgba(29, 57, 100, 0.23);
}

.table.border-separate thead th,
.table.border-separate thead td {
  border: none;
}
</style>

<script>
import ApiService from "@/common/api.service";
import { mapGetters, mapState } from "vuex";
import {
  FETCH_APPLICATION,
  CLEAR_SAVE_MESSAGE,
  GET_DECLARATIONS_REQUESTS,
  CHECK_LABEL,
  GET_CURRENT_REQUESTS_DECLARATIONS,
  GET_COMPLETED_REQUESTS_DECLARATIONS,
  FETCH_ECOSYSTEM_APPLICATION 
} from "@/store/actions.type";
import ButtonVue from "../../components/spKit/Button.vue";

import store from "@/store";
import CompanyVue from "../../components/pages/Company.vue";
import Tabs from "../../components/Candidat/Tabs.vue";
import Loader from "@/components/Loader.vue";
import {
  SET_LabelApp,
  SET_LabelMenuActive,
  SET_HashId,
  SET_ECOSYSTEM_MENU_ACTIVE
} from "@/store/mutations.type";

export default {
  name: "Declarations",
  components: {
    "sp-button": ButtonVue,
    company: CompanyVue,
    tabs: Tabs,
    Loader
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(CLEAR_SAVE_MESSAGE);
    this.$store.commit(SET_ECOSYSTEM_MENU_ACTIVE, false);
    next();
  },
  data() {
    return {
      requests: null,
      checkApp: false,
      labelData: null,
      loading: true,
      messageCompany: false,
      requets_declarations: [],
      companyData: null,
      currRequestDeclarations: [],
      complRequestDeclarations: [],
    };
  },
  mounted() {
    if (!this.isStartupEcosystem && localStorage.getItem('ecosystem') !== 'true') {
      this.$store.commit(SET_HashId, this.$route.params.app_id);
      this.$store.dispatch(CHECK_LABEL, this.$route.params.app_id);
    }
    this.$store
      .dispatch(GET_CURRENT_REQUESTS_DECLARATIONS, this.$route.params.app_id)
      .then(data => {
        this.currRequestDeclarations = data;
      });
    // Completed declarations
    this.$store
      .dispatch(
        GET_COMPLETED_REQUESTS_DECLARATIONS,
        this.$route.params.app_id
      )
      .then(data => {
        this.complRequestDeclarations = data;
      });

    // List requests declarations
    this.$store.dispatch(GET_DECLARATIONS_REQUESTS, this.currentApplicationType ? this.currentApplicationType : this.$route.params.appType.toUpperCase()).then(data => {
      this.requets_declarations = data.requests_declarations;
    });
    this.$store.dispatch(FETCH_ECOSYSTEM_APPLICATION, this.$route.params.app_id);

    if (this.isStartupEcosystem || localStorage.getItem('ecosystem') === 'true') {
      this.loading = false;
    } else if (this.session.startup_application == null) {
      this.$store
        .dispatch(FETCH_APPLICATION, this.$route.params.app_id)
        .then(() => {
          this.checkLabel();
        });
    } else if (this.session.startup_application.label_ref) {
      this.checkLabel();
    }
  },
  methods: {
    applyRequest(id) {
      this.$router.push({
        name: "declarationForm",
        params: {
          appType: this.currentApplicationType.toLowerCase(),
          formName: id,
          ecoAppId: this.$route.params.app_id
        }
      });
    },
    formatDeclarationCodeName(code) {
      return code.toLowerCase().replaceAll("_", "-");
    },
    checkLabel() {
      ApiService.get(`/api/requests/check_label/${this.hashId}`)
        .then(data => {
          if (data.data.data.application != null) {
            this.$store.commit(SET_LabelMenuActive, 1);
            let label_ref = data.data.data.label_ref;
            if (label_ref) {
              ApiService.get(`/api/requests/verify/${label_ref}`)
                .then(data => {
                  this.checkApp = true;
                  this.labelData = data.data.data;
                  this.companyData = this.labelData.company;
                  this.getLabel();
                })
                .catch(response => {
                  this.checkApp = false;
                  this.labelData = null;
                });
            }
          } else {
            this.$store.commit(SET_LabelMenuActive, 0);
          }
        })
        .catch(response => {
          this.$store.commit(SET_LabelMenuActive, 0);
          this.$router.push({ name: "home" });
        });
    },
    getLabel() {
      ApiService.get(`/api/requests/${this.LabelApplication}`)
        .then(data => {
          this.requests = data.data.data;
          var accepted_request = [];
          this.requests.accepted_request.forEach(function(value, key) {
            accepted_request.push(value.type_id);
          });
          if (accepted_request.includes(6)) {
            this.requests.default_request;
          } else {
            this.requests.default_request.splice(1, 1);
          }

          this.loading = false;
        })
        .catch(response => {
          this.requests = null;
        });
    },
    CompanyLink() {
      this.$router.push({ name: "Entreprise" });
    },
    shouldDisableButton(lab) {
      if(lab.code_name != "DECLARATION_DU_GROUPE_STURTUP" && this.currentApplicationType == "Sail")
      return !this.hasGroupDeclaration;
    }
  },
  computed: {
    ...mapGetters(["session", "hashId", "LabelApplication", "ecosystemApp"]),
    currentApplicationType() {
      // this.$store.dispatch(FETCH_ECOSYSTEM_APPLICATION, this.$route.params.app_id);
      if(this.isStartupEcosystem || localStorage.getItem('ecosystem') === 'true') {
        if(this.ecosystemApp.application)
        return this.ecosystemApp.application.type;
      } else {
        if(this.session.startup_application)
        return this.session.startup_application.type;
      }
      // return (this.isStartupEcosystem || localStorage.getItem('ecosystem') === 'true') ?
      //   this.ecosystemApp.application.type :
      //   this.session.startup_application.type;
    },
    isStartupEcosystem() {
      let startupEco = false;
      let hashId = this.$route.params.app_id || this.$route.params.ecoAppId;
      if (hashId) {
        if (
          this.ecosystemApp &&
          this.ecosystemApp.application &&
          ["Air", "Air2", "D4D"].includes(this.ecosystemApp.application.type) &&
          this.ecosystemApp.application.id == hashId
        ) {
          startupEco = true;
        }
      }

      return startupEco;
    },
    decalarationsPageTitle() {
      return this.isStartupEcosystem || localStorage.getItem('ecosystem') === 'true' ?
        this.$i18n.t('declarations.new_declaration_reporting'):
        this.$i18n.t('declarations.new_declaration');
    },
    ...mapState({
      saveMessage: state => state.request.saveMessage
    }),
    hasGroupDeclaration() {
      if (!this.complRequestDeclarations) {
        return false;
      } else {
          const groupDeclaration = this.complRequestDeclarations.find(
          declaration => declaration.code_name === "DECLARATION_DU_GROUPE_STURTUP"
        );
        return Boolean(groupDeclaration);
      }
    }
  }
};
</script>

<style>
</style>
